import BaseService from "@/boot/BaseService";
class SupersetService extends BaseService {
  constructor() {
    super(null, "/superset");
  }
  async getToken(params) {
    return await this.get("/get-token", params);
  }
}

export default new SupersetService();
